import { render } from "./BloodPanelTestSelection.vue?vue&type=template&id=6c042ce8&scoped=true"
import script from "./BloodPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./BloodPanelTestSelection.vue?vue&type=script&lang=js"

import "./BloodPanelTestSelection.vue?vue&type=style&index=0&id=6c042ce8&lang=scss&scoped=true"
import "./BloodPanelTestSelection.vue?vue&type=style&index=1&id=6c042ce8&lang=scss"
import "./BloodPanelTestSelection.vue?vue&type=style&index=2&id=6c042ce8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c042ce8"],['__file',"src/components/cases/testInfo/testSelection/BloodPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c042ce8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c042ce8', __exports__)) {
    console.log('reload')
    api.reload('6c042ce8', __exports__)
  }
  
  module.hot.accept("./BloodPanelTestSelection.vue?vue&type=template&id=6c042ce8&scoped=true", () => {
    console.log('re-render')
    api.rerender('6c042ce8', render)
  })

}


export default __exports__